import React from 'react';
export function Impact() {
  return <section className="py-16 px-6 bg-gray-50" data-id="element-118">
      <div className="max-w-4xl mx-auto text-center" data-id="element-119">
        <div className="mb-8 inline-block" data-id="element-120">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bv38HwedDiAWjvAZUiys7u/image.png" alt="Jim Morgan" className="h-24 w-24 object-cover rounded-full mx-auto border-4 border-[#1E3A5F]" data-id="element-121" />
        </div>
        <blockquote className="text-xl md:text-2xl text-gray-700 italic mb-6" data-id="element-122">
          "I believe that every person, regardless of their education or
          training, is capable of improving their leadership and management
          skills."
        </blockquote>
        <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-123">
          Over the years, tens of thousands of leaders have received free copies
          of Applied Wisdom. Most tell us they have found it useful in their
          leadership and work.
        </p>
      </div>
    </section>;
}